import React from 'react';

interface AdSlotProps {
  format?: 'banner' | 'card' | 'sidebar';
  label?: string;
  className?: string;
}

export const AdSlot: React.FC<AdSlotProps> = ({
  format = 'card',
  label = 'Sponsored Recommendation',
  className = '',
}) => {
  return (
    <div className={`p-4 bg-[#FBFBFC] border border-[#E5E7EB] rounded-2xl space-y-2 relative overflow-hidden ${className}`}>
      <div className="flex items-center justify-between text-[10px] font-bold uppercase tracking-wider text-[#9CA3AF]">
        <span>{label}</span>
        <span>Ethical Disclosure</span>
      </div>

      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 pt-1">
        <div className="space-y-0.5">
          <div className="text-xs font-bold text-[#1A1A1A]">
            Compare Low-Fee Global Multi-Currency Accounts
          </div>
          <div className="text-[11px] text-[#6B7280]">
            Save up to 8x on international transfers with verified mid-market rates and zero monthly fees.
          </div>
        </div>

        <button className="px-3.5 py-1.5 bg-white hover:bg-[#F3F4F6] text-[#1A1A1A] border border-[#E5E7EB] text-xs font-bold rounded-xl whitespace-nowrap transition-colors shrink-0">
          View Verified Providers →
        </button>
      </div>
    </div>
  );
};
